import React from 'react';
import styled from 'styled-components';
import AuditTimeline from '../components/audit/AuditTimeline';
import HomeButton from '../components/header/HomeButton';
import { useLoggedIn } from '../hooks/use.logged.in';

const AuditLog = () => {
  useLoggedIn();

  return (
    <s-page inlineSize='large'>
      <Container>
        <HomeButton title='Audit log' />
        <Intro>Sign-ins and every change made through CS Admin across all shops.</Intro>
        <AuditTimeline showFilters />
      </Container>
    </s-page>
  );
};

export default AuditLog;

const Container = styled.div`
  display: grid;
  gap: 16px;
  min-width: 0;
`;

const Intro = styled.p`
  color: #6d7175;
`;
